import type { Sticky } from '../../../shared/types.ts';

const SHADOW = 'rgba(0, 0, 0, 0.08)';

export function drawSticky(ctx: CanvasRenderingContext2D, o: Sticky, lod: boolean): void {
  // A flat offset rect instead of shadowBlur, which is far too slow at scale.
  if (!lod) {
    ctx.fillStyle = SHADOW;
    ctx.fillRect(0, 4, o.w, o.h);
  }
  ctx.fillStyle = o.color;
  ctx.fillRect(0, 0, o.w, o.h);
  // Text rendering arrives with the text cache in phase 2.
}
